import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"icon-plus\">\n  <g fill=\"#171818\" fill-rule=\"evenodd\">\n    <rect width=\"1\" height=\"19\" x=\"9\" rx=\".5\" />\n    <path d=\"M9.5,0 C9.77614237,-5.07265313e-17 10,0.223857625 10,0.5 L10,18.5 C10,18.7761424 9.77614237,19 9.5,19 C9.22385763,19 9,18.7761424 9,18.5 L9,0.5 C9,0.223857625 9.22385763,5.07265313e-17 9.5,0 Z\" transform=\"rotate(90 9.5 9.5)\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol